import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 各未読数の取得
 *
 * チャット、アポイントメントの未読数を取得する
 */
export class GetUnread implements APIRequest<Monitaro.GetUnreadResponse> {
  response: Monitaro.GetUnreadResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor() {
    this.path = `/notifications/unread`
  }
}
